/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserBadgeResponse
 */
export interface UserBadgeResponse {
    /**
     * 
     * @type {string}
     * @memberof UserBadgeResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UserBadgeResponse
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof UserBadgeResponse
     */
    badgeId: string;
    /**
     * 
     * @type {string}
     * @memberof UserBadgeResponse
     */
    streakConfigId?: string;
    /**
     * 
     * @type {string}
     * @memberof UserBadgeResponse
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UserBadgeResponse
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof UserBadgeResponse
     */
    iconUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof UserBadgeResponse
     */
    earnedAt: number;
}

/**
 * Check if a given object implements the UserBadgeResponse interface.
 */
export function instanceOfUserBadgeResponse(value: object): value is UserBadgeResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('badgeId' in value) || value['badgeId'] === undefined) return false;
    if (!('earnedAt' in value) || value['earnedAt'] === undefined) return false;
    return true;
}

export function UserBadgeResponseFromJSON(json: any): UserBadgeResponse {
    return UserBadgeResponseFromJSONTyped(json, false);
}

export function UserBadgeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserBadgeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'userId': json['userId'],
        'badgeId': json['badgeId'],
        'streakConfigId': json['streakConfigId'] == null ? undefined : json['streakConfigId'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'iconUrl': json['iconUrl'] == null ? undefined : json['iconUrl'],
        'earnedAt': json['earnedAt'],
    };
}

export function UserBadgeResponseToJSON(json: any): UserBadgeResponse {
    return UserBadgeResponseToJSONTyped(json, false);
}

export function UserBadgeResponseToJSONTyped(value?: UserBadgeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'userId': value['userId'],
        'badgeId': value['badgeId'],
        'streakConfigId': value['streakConfigId'],
        'name': value['name'],
        'description': value['description'],
        'iconUrl': value['iconUrl'],
        'earnedAt': value['earnedAt'],
    };
}

